import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'
import VueTagManager from 'vue-tag-manager'
import { event } from 'vue-analytics'
import track from '@/plugins/track'
import client from '@/store/client'
import VueMask from 'v-mask'


(async () => {
  await store.dispatch('GET_PRACTICES')
  store.dispatch('SET_SUBDOMAIN')
  if(store.state.onSubdomain) {
    Vue.use(VueAnalytics, {
      id: store.state.selectedPractice.hPPlusGA,
      router,
    })

    Vue.use(VueTagManager, {
      gtmId: store.state.selectedPractice.hPPlusGTM,
    })
  }
  else {
    Vue.use(VueAnalytics, {
      id: 'UA-179245834-1',
      router,
    })

    Vue.use(VueTagManager, {
      gtmId: 'GTM-MGPBRBQ',
    })
  }

  Vue.config.productionTip = false
  Vue.use(VueScrollTo)
  Vue.use(VueMask);
  
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')

})()
